import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { configURI } from '../../../shared/apiUrlConfig';
import { InsuranceDoc } from '../../model/insurance.model'
import { APP_ID_RANDOM_PROVIDER } from '@angular/core/src/application_tokens';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import * as momenttimezone from 'moment-timezone';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GetDocStatusByRole } from '../../../shared/globalService';

@Injectable()
export class LicenseDataService {
  load;
  url = environment.configURI;
  loginId;
  agentId;
  constructor(
    private getDocStatusByRole: GetDocStatusByRole,
    private http: Http, private userFriendlyMsgs: UserFriendlyMsgs, public httpClient: HttpClient) {
    this.load = new BehaviorSubject('initial');
    this.agentId = localStorage.getItem("AgentId");
  }

  // get agent Docs
  insuranceDocGet(id) {
    let role = parseInt(localStorage.getItem("RoleVal"))
    if (role === 8) {
      return this.httpClient.get(this.url + '/client/vendor/' + id + '/license').catch(this.userFriendlyMsgs.errorHandler)
    } else {
      return this.httpClient.get(this.url + '/vendor/' + id + '/license').catch(this.userFriendlyMsgs.errorHandler)
    }
  }

  // get details of agent
  insdetails(docId) {
    return this.httpClient.get(this.url + '/vendors/license/document/' + docId).catch(this.userFriendlyMsgs.errorHandler)
  }


  licensedoctypeget() {
    return this.httpClient.get(this.url + '/documents/GetDocumentTypesByCategory?Category=LICENSE').catch(this.userFriendlyMsgs.errorHandler)
  }

  // create new agent info
  createNewAgentLicense(data, type?) {
    this.loginId = localStorage.getItem('loginID');
    const setTime = new Date(data.expirationdate);
    setTime.setHours(19);
    setTime.setMinutes(59);
    setTime.setSeconds(59);
    const estTimeZone = "America/New_York";
    const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
    var testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
    /*** The following logic for Daylight Savings ***/
    if (testTimeZone.includes('-05:00')) {
      testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
    }

    const body = {
      expirationdate: testTimeZone,
      issuedate: data.issuedate,
      issuestate: data.issuestate,
      filename: data.fileName,
      licensenumber: data.licensenumber,
      documentType: data.documentType,
      documentName: data.documentName,
      vendor_id: data.MasterVendorId,
      uploadDate: data.uploadDate,
      documentLink: data.documentLink,
      created_by: this.loginId,
      DocumentStatus: this.getDocStatusByRole.docStatusByRole()
    }
    return this.httpClient.post(this.url + '/vendors/license', body).catch(this.userFriendlyMsgs.errorHandler);
  }

  // update new agent info
  updateAgentLicense(data, type?) {
    this.loginId = localStorage.getItem('loginID');
    const setTime = new Date(data.expirationdate);
    setTime.setHours(19);
    setTime.setMinutes(59);
    setTime.setSeconds(59);
    const estTimeZone = "America/New_York";
    const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
    var testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
    /*** The following logic for Daylight Savings ***/
    if (testTimeZone.includes('-05:00')) {
      testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
    }

    const body = {
      vendor_id: data.MasterVendorId,
      expirationdate: testTimeZone,
      issuedate: data.issuedate,
      issuestate: data.issuestate,
      filename: data.fileName,
      licensenumber: data.licensenumber,
      documentType: data.documentType,
      documentName: data.documentName,
      uploadDate: data.uploadDate,
      documentLink: data.documentLink,
      updated_by: this.loginId,
      DocumentStatus: this.getDocStatusByRole.docStatusByRole(),
      DocumentComments : data.DocumentComments,
      fileUpdated: data.fileUpdated
    }
    return this.httpClient.put(this.url + '/vendors/license/document/' + data.docid, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  approveLicense(data, type?) {
    this.loginId = localStorage.getItem('loginID');

    const body = {
      vendor_id: data.MasterVendorId,
      expirationdate: data.expirationdate,
      issuedate: data.issuedate,
      issuestate: data.issuestate,
      filename: data.fileName,
      licensenumber: data.licensenumber,
      documentType: data.documentType,
      documentName: data.documentName,
      uploadDate: data.uploadDate,
      documentLink: data.documentLink,
      updated_by: this.loginId,
      DocumentStatus: "Approved"
    }
    return this.httpClient.put(this.url + '/vendors/license/document/' + data.docid, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  rejectLicense(data, type?) {
    this.loginId = localStorage.getItem('loginID');

    const body = {
      vendor_id: data.MasterVendorId,
      expirationdate: data.expirationdate,
      issuedate: data.issuedate,
      issuestate: data.issuestate,
      filename: data.fileName,
      licensenumber: data.licensenumber,
      documentType: data.documentType,
      documentName: data.documentName,
      uploadDate: data.uploadDate,
      documentLink: data.documentLink,
      updated_by: this.loginId,
      DocumentStatus: "Rejected",
      DocumentComments:data.DocumentComments

    }
    return this.httpClient.put(this.url + '/vendors/license/document/' + data.docid, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  validateDocument(data, type?){
    this.loginId = localStorage.getItem('loginID');

    const body = {
      vendor_id: data.MasterVendorId,
      expirationdate: data.expirationdate,
      issuedate: data.issuedate,
      issuestate: data.issuestate,
      filename: data.fileName,
      licensenumber: data.licensenumber,
      documentType: data.documentType,
      documentName: data.documentName,
      uploadDate: data.uploadDate,
      documentLink: data.documentLink,
      updated_by: this.loginId,
      DocumentStatus: "In Progress"
    }
    return this.httpClient.put(this.url + '/vendors/license/document/' + data.docid, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  deleteAgentInsurance(data) {
    return this.httpClient.delete(this.url + '/vendors/license/document/' +  this.agentId + '/' + data._id).catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/agentLicense/license-data.service.ts